exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flyer-thumbnail-wrapper .flyer-thumbnail {\n  position: relative;\n  cursor: pointer;\n  background-color: white;\n  margin-right: 10px;\n  text-align: center;\n  padding: 2px;\n  display: inline-block;\n  overflow: hidden;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);\n  margin-top: 10px;\n  width: 200px;\n  height: 200px; }\n\n.flyer-thumbnail-wrapper .flyer-run-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.flyer-thumbnail-wrapper .flyer-thumbnail-check {\n  position: absolute;\n  right: 3px;\n  top: 3px;\n  height: 20px;\n  width: 20px;\n  z-index: 100;\n  border-radius: 10px;\n  background-color: #466e9f; }\n\n.flyer-thumbnail-wrapper .flyer-thumbnail-img {\n  width: auto;\n  height: 150px;\n  position: absolute;\n  top: 0px;\n  left: 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/common/components/QuerySelector/FlyerThumbnail/style.scss
// module id = 1025
// module chunks = 0